$(document).ready(function () {

    checkVisibility();

    $('body').on('scroll ready load orientationchange resize', function () {
        checkVisibility();
    });

    $('.js-discover-more').on('click', function () {

        var next_section = $(this).closest('section').next('section');

        $('body, html').animate({
            scrollTop: next_section.offset().top
        }, 500);

    });

});

function checkVisibility() {
    var counter = 0;
    $('.js-animate-in').each(function () {
        if ($(this).visible(true)) {
            $(this).delay(counter * 250).queue(function (next) {
                $(this).addClass('visible');
                next();
            });
            counter++;
        }
    });
}